import {useRef} from "react"
import Text from "../../components/input/text";
import Textarea from "../../components/input/textarea";
import Button from "../../components/button";
import Alert from "../../components/alert";
import UseGetFormData from "../../hooks/UseGetFormData";
import {sms_info} from "../../config/tips";
import CardMenu from "../../components/card-menu";
import Menu from "./Menu"
import Select from "../../components/input/select";

const Form = (props) => {
    const {sms, content, enterprises, errors, isReady, onSubmit, onChangeContent, onInsertVariable} = props
    const formRef = useRef()


    const handleSubmit = (ev) => {
        ev.preventDefault()
        const FormData = UseGetFormData(formRef)
        onSubmit({
            title        : FormData.get('title'),
            sender        : FormData.get('sender'),
            content      : FormData.get('content'),
            id_enterprise: FormData.get('id_enterprise'),
        })
    }


    const handleVariables = (ev) => {
        if(typeof onInsertVariable === "function"){
            onInsertVariable(ev.target.id)
        }
    }



    const handleContentChange = (ev) => {
        if(typeof onChangeContent === "function"){
            onChangeContent(ev)
        }
    }


    return (
        <form autoComplete="off" ref={formRef} onSubmit={handleSubmit}>
            <CardMenu {...Menu} />

            <Alert
                icon="info"
                docsPath="/docs/sms"
                message={sms_info}
            />

            <Text required
                size="md"
                name="title"
                label="Title"
                isReady={isReady}
                error={errors && errors['info.title']}
                value={sms?.title}
                placeholder="Type a title for your sms"
            />

            <Select required
                size="md"
                isReady={isReady}
                label="Enterprise"
                name="id_enterprise"
                options={enterprises}
                value={sms?.id_enterprise?.$oid}
                error={errors && errors['info.id_enterprise']}
                placeholder="Choose an enterprise"
            />

            <Text
                counter
                required
                size="md"
                name="sender"
                maxLength={11}
                label="Sender Name"
                isReady={isReady}
                error={errors && errors['info.sender']}
                value={sms?.sender}
                placeholder="Type a sender name for your sms"
            />

            <Textarea
                counter
                required
                size="md"
                name="content"
                label="Message"
                isReady={isReady}
                error={errors && errors['info.content']}
                value={content}
                placeholder="Type the body of your SMS here"
            />

            <div className="d-flex">
                <Button
                    size="sm"
                    color="primary"
                    isReady={isReady}
                    icon={sms ? 'check' : 'plus'}
                    label={sms ? 'Update' : 'Create'}
                />
            </div>
        </form>
    )
}

export default Form